import { useCallback, useEffect } from "react";

import { translate } from "src/services";
import { theme } from "src/styles";
import { ThemeProvider } from "styled-components";
import {
  Button,
  ButtonSet,
  Confirmation as ConfirmationContainer,
  ConfirmationDialog,
  ConfirmationMessage,
  ConfirmationTitle,
} from "../styled";

interface Props {
  message?: string;
  noLabel?: string;
  reject: (value: any) => void;
  resolve: (value: any) => void;
  title: string;
  yesLabel?: string;
}

const Confirmation = ({ message, noLabel, reject, resolve, title, yesLabel }: Props) => {
  const accept = useCallback(
    (value?: any) => {
      resolve(value);
    },
    [resolve]
  );

  const cancel = useCallback(
    (value?: any) => {
      reject(value);
    },
    [reject]
  );

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        cancel();
      }

      if (event.key === "Enter") {
        accept();
      }
    },
    [accept, cancel]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  return (
    <ThemeProvider theme={theme}>
      <ConfirmationContainer>
        <ConfirmationDialog>
          <ConfirmationTitle>{title}</ConfirmationTitle>
          <ConfirmationMessage>{message}</ConfirmationMessage>
          <ButtonSet align="right">
            <Button line color="primary" margin="no small no no" onClick={cancel}>
              {noLabel || translate("common.no")}
            </Button>

            <Button color="primary" onClick={accept}>
              {yesLabel || translate("common.yes")}
            </Button>
          </ButtonSet>
        </ConfirmationDialog>
      </ConfirmationContainer>
    </ThemeProvider>
  );
};

export default Confirmation;
